import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "FrontEditTemplateWrapper";

export const classes = {
  templateSection: `${PREFIX}-templateSection`,
  actionButtonContainer: `${PREFIX}-actionButtonContainer`,
  actionButton: `${PREFIX}-actionButton`,
};

const StyledFrontEditTemplateWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto min-content",

  [`& .${classes.templateSection}`]: {
    gridColumn: "1",
    border: "none",
    boxShadow: "none",
  },
  [`& .${classes.actionButtonContainer}`]: {
    gridColumn: "2",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  [`& .${classes.actionButton}`]: {
    position: "absolute",
    background: "white",
    right: "calc(25% + 15px)",
    zIndex: "1101",
    borderRadius: "4px",
    border: "1px solid black",
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.down("sm")]: {
      right: "15px",
    },
  },
}));

export default StyledFrontEditTemplateWrapper;
